// src/context/AuthProvider.jsx
import React, { useState, useEffect, createContext } from 'react';
import { Global } from '../helpers/Global';
import { jwtDecode } from 'jwt-decode';

// ⬇️ Siembra datos offline (centros) — sigue vigente
import { primeOfflineData } from '../offline/bootstrap';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  // ⛳️ MIGRACIÓN (opcional pero MUY recomendable):
  // borra las claves antiguas del flujo "ticajeClient" para evitar estados colgados.
  useEffect(() => {
    try {
      if (!localStorage.getItem('__migr_v2_done')) {
        localStorage.removeItem('pwa.jornada.activa');
        localStorage.removeItem('pwa.jornada.outbox');
        localStorage.removeItem('pwa.cache.centros');
        localStorage.setItem('__migr_v2_done', '1');
      }
    } catch {}
  }, []);

  useEffect(() => {
    initAuth();
  }, []);

  // Si ya hay auth (p.ej. login reciente) y hay red, vuelve a sembrar
  useEffect(() => {
    if (auth?.id && navigator.onLine) {
      primeOfflineData().catch(() => {});
    }
  }, [auth?.id]);

  const isTokenExpired = (token) => {
    try {
      const { exp } = jwtDecode(token);
      return exp < (Date.now() / 1000);
    } catch {
      return true;
    }
  };

  const logout = () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } catch {}
    setAuth(null);
  };

  const initAuth = async () => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');

    if (!token || !userStr || isTokenExpired(token)) {
      logout();
      setLoading(false);
      return;
    }

    // 1) Carga inmediata desde localStorage (funciona offline)
    let localUser = null;
    try { localUser = JSON.parse(userStr); } catch {}
    if (localUser) setAuth(localUser);
    setLoading(false);

    // 2) Si hay red: siembra datos offline y refresca perfil en segundo plano
    if (navigator.onLine) {
      try { await primeOfflineData(); } catch {}

      try {
        const res = await fetch(`${Global.url}usuarios/profile/${localUser.id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          cache: 'no-store',
        });

        if (res.status === 401) {
          logout();
          return;
        }

        if (res.ok) {
          const data = await res.json().catch(() => null);
          if (data?.user) {
            setAuth({ ...data.user });
            try { localStorage.setItem('user', JSON.stringify(data.user)); } catch {}
          }
        }
        // Otros códigos: conserva el auth local (sesión offline sigue)
      } catch {
        // Error de red: no rompas la sesión offline
      }
    }
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
